import { OptOutRow as SharedOptOutRow } from '@/features/dryad';
import { ConditionType } from './condition-types';
import { ConditionTypeSelect } from './condition-type-select';
import { DEFAULT_OPT_OUT_NEGATE_WORDING } from './opt-out-plugin';

type OptOutRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/** The people surface's binding of the shared opt-out row. */
export function OptOutRow({ id }: OptOutRowProps) {
  return (
    <SharedOptOutRow
      id={id}
      conditionType={ConditionType.OptOut}
      negateWording={DEFAULT_OPT_OUT_NEGATE_WORDING}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.OptOut} />}
    />
  );
}
